module.exports = __webpack_public_path__ + "img/drop-off-rates.11b519f2.svg";